// File: client_serena/src/components/ProtectedRoute.js
import React from "react";
import { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const [currentUser, setCurrentUser] = useState(() => getAuth().currentUser);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    return onAuthStateChanged(getAuth(), (user) => {
      setCurrentUser(user);
      setIsCheckingAuth(false);
    });
  }, []);

  if (isCheckingAuth) return null;

  return currentUser ? children : <Navigate to="/login" replace />;
}



